import { Table, Tbody, Td, Th, Thead, Tr } from '@televet/kibble-ui';
import React from 'react';
import Switch from 'shared/components/Switch';
import { WorkflowEventAction } from 'shared/types/graphql';
import { getClinicWidgetRequestTypeDisplayName } from 'shared/utils/widgetRequests';
import { WidgetRequestTypeRow } from '../../../types';
import AssigneeSelector from '../../AssigneeSelector';

export type AutomationTaskRow = {
  taskName: string;
  automationName: string;
  assigneeIds: string[];
  settingId: string;
  getUpdatedAction: (finalAssigneeList: string[]) => Partial<WorkflowEventAction>;
};

type WidgetRequestsTableProps = {
  data: WidgetRequestTypeRow[],
  updateTaskCreation: (id: string, shouldCreate: boolean) => void;
  updateAssignees: (widgetRequestType: WidgetRequestTypeRow, assigneeId: string, isAdding: boolean) => void;
  hasPermission: boolean;
};

const WidgetRequestsTable = ({ data, updateTaskCreation, updateAssignees, hasPermission }: WidgetRequestsTableProps): JSX.Element => {
  return <Table width="100%" textAlign="left" verticalAlign="middle" fontWeight="normal">
    <Thead>
      <Th textTransform="uppercase" pb={3} px={2} fontWeight="normal">Request Name</Th>
      <Th textTransform="uppercase" pb={3} px={2} fontWeight="normal">Create Task</Th>
      <Th textTransform="uppercase" pb={3} px={2} fontWeight="normal">Assignees</Th>
    </Thead>
    <Tbody>
      {data.map(({ displayName, requestType, id, shouldCreateTask, selectedAssigneesId }, index) => (
        <Tr
          key={id}
          _odd={{ bg: 'background.default' }}
          css={`&:last-of-type td {border-bottom: none;}`}
        >
          <Td py={3} px={2} fontSize="sm">{getClinicWidgetRequestTypeDisplayName({ requestType, displayName })}</Td>
          <Td py={3} px={2} fontSize="sm">
            <Switch
              name={`${id}-shouldCreateTask`}
              disabled={!hasPermission}
              data-testid={`add-to-tasks-switch-${id}`}
              label=""
              checked={shouldCreateTask}
              onChange={(e, checked): void =>
                updateTaskCreation(id, checked)
              }
            />
          </Td>
          <Td py={3} px={2} fontSize="sm">
            <AssigneeSelector
              selectedUserIds={selectedAssigneesId}
              onToggle={hasPermission ? (option): void => {
                updateAssignees(data[index], option.value.id, !option.isSelected);
              } : undefined}
            />
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
};

export default WidgetRequestsTable;
